<template>
    <div id="modal-template">
        <transition name="slide-up">
            <div class="filter-container" v-show="show">
                <app-header>
                    <template slot="title">Filter wählen</template>
                    <template slot="right">
                        <img src="../assets/images/x.svg" alt="close"
                             @click="close">

                    </template>
                </app-header>

                <div class="container">
                    <div class="font-title-big">Wähle die Trends die dich wirklich interessieren.</div>
                    <div class="font-normal">Filtere deine Einnahmen nach einzelnen Songs, Länder etc.</div>
                    <div id="list">
                        <table class="table">
                            <tbody>
                            <app-list-filter-item v-for="item in list" :item="item"></app-list-filter-item>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
  import Header from '../components/Header'
  import data from '../data/filter'
  import ListFilterItem from '../components/filter/ListFilterItem'

  export default {
    props: ['show'],
    data () {
      return {
        list: data
      }
    },
    components: {
      appHeader: Header,
      appListFilterItem: ListFilterItem
    },
    methods: {
      close () {
        this.$emit('close')
      }
    }

  }
</script>

<style lang="scss" scoped>
    .container {
        padding: 20px;
    }

    #list {
        margin-top: 10px;
    }
</style>
